import { createFileRoute } from "@tanstack/react-router";
import { CreateCommandePage } from "@/features/achats/components/commandes/CreateCommandePage";

export const Route = createFileRoute("/_app/achats/commandes/create")({
  staticData: {
    title: "Nouvelle commande",
    showInBreadcrumb: true,
  },
  component: CreateCommandePage,
});
